import * as React from 'react';
import { memo } from 'react';

export type TileCellProps = {
	info?: string;
	children?: React.ReactNode;
	label?: string;
	text?: string;
	modifiers?: string[];
};

export type TileProps = {
	children?: React.ReactNode;
	line?: boolean;
};

export type TilesProps = {
	modifier?: string;
	title?: string;
	children?: React.ReactNode;
};

export const CellComponent = ({ info, children, label, text, modifiers = [] }: TileCellProps) => {
	const classNames = ['m-tiles__cell', ...modifiers];

	return (
		<div className={classNames.join(' ')}>
			{info && <span className="m-tiles__box-info">{info}</span>}
			<div className="m-tiles__box">{children}</div>
			{text && <span className="m-tiles__box-text">{text}</span>}
			{label && (
				<span
					className={`m-tiles__box-label${text ? ` m-tiles__box-label--yellow` : ''}`}
					dangerouslySetInnerHTML={{ __html: label }}
				/>
			)}
		</div>
	);
};

export const TileComponent = ({ children, line = false }: TileProps) => (
	<React.Fragment>
		<div className="m-tiles__row">{children}</div>
		{line && <hr className="m-tiles__line" />}
	</React.Fragment>
);

export const TilesComponent = ({ modifier, title, children }: TilesProps) => (
	<div className={`m-tiles${modifier ? ` m-tiles--${modifier}` : ''}`}>
		{title && <h2 className="m-tiles__title">{title}</h2>}
		{children}
	</div>
);

export const Cell = memo(CellComponent);
export const Tile = memo(TileComponent);

export default memo(TilesComponent);
